module.exports = __webpack_public_path__ + "img/Rogue-dwarf-m-70.d700f27e.gif";